import React from 'react';
import intl from 'react-intl-universal';

import {useDsManager, useRootStore} from '@stores/AppStateContext';
import {useBasicDataSourceDeps} from '../../../platform/hooks/useDataSourceDependencies';
import type {AuditTemplate} from '../../../stores/audit/types';
import {deleteAudit} from '../../../actions/audit/deleteAudit';
import {ModalConfirm} from '../../components/ModalConfirm/ModalConfirm';

export interface AuditDeleteConfirmModalProps {
    template: AuditTemplate | null;
    onClose: () => void;
}

export const AuditDeleteConfirmModal = ({template, onClose}: AuditDeleteConfirmModalProps) => {
    const rootStore = useRootStore();
    const dsManager = useDsManager();
    const dsDeps = useBasicDataSourceDeps();
    const wsId = rootStore.view.workspace?.id;
    const auditName = template?.name || intl.get('audits.list.untitled').d('Untitled');

    const handleDelete = async () => {
        if (!template || !wsId) return;
        await deleteAudit(dsDeps.dataClientService, dsDeps.authService, wsId, template.id);
        onClose();
        dsManager?.getAuditsDataSource(wsId).removeAuditTemplate(template.id);
    };

    return (
        <ModalConfirm
            open={!!template}
            type={'danger'}
            header={intl.get('audits.delete.header').d('Delete audit')}
            confirmText={intl.get('common.delete').d('Delete')}
            onConfirm={handleDelete}
            onCancel={onClose}
            onClose={onClose}
        >
            {intl.getHTML('audits.delete.body', {auditName})
                .d(`Are you sure you want to delete audit <b>“{auditName}”</b>? Questions, runs, answers, and audit findings will also be deleted. This cannot be undone.`)}
        </ModalConfirm>
    );
};
